import React from 'react';
import { Card, Typography, Space, Tag, Button } from 'antd';
import { useGlobalStore, type GlobalState } from '@digiwedge/global-state';

function decodeJwt(token: string): Record<string, unknown> | null {
  try {
    const parts = token.split('.');
    if (parts.length < 2) return null;
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = atob(payload);
    return JSON.parse(json) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export default function PortalAuthDiagnosticsPanel(): React.ReactElement {
  const { Text } = Typography;
  const token = useGlobalStore((s: GlobalState) => s.token);
  const logout = useGlobalStore((s: GlobalState) => s.logout);
  const claims = token ? decodeJwt(token) : null;
  const exp = typeof claims?.exp === 'number' ? (claims.exp as number) : undefined;
  const nowSec = Math.floor(Date.now() / 1000);
  const valid = Boolean(token && (!exp || exp > nowSec));

  return (
    <Card title="Portal Auth State">
      <Space direction="vertical" style={{ width: '100%' }}>
        <Space size="small" wrap>
          <Tag color={valid ? 'green' : 'red'}>{valid ? 'VALID' : 'MISSING/EXPIRED'}</Tag>
          {typeof exp === 'number' && (
            <Text type="secondary">exp: {new Date(exp * 1000).toISOString()}</Text>
          )}
        </Space>
        {token ? (
          <>
            <Text strong>Subject</Text>
            <Text code>{String((claims?.sub as string) ?? (claims?.email as string) ?? '—')}</Text>
            <Text strong>Claims</Text>
            <pre style={{ margin: 0, maxHeight: 260, overflow: 'auto' }}>
              {JSON.stringify(claims ?? {}, null, 2)}
            </pre>
            <Button onClick={() => logout()}>Logout</Button>
          </>
        ) : (
          <Text type="secondary">No access token in store.</Text>
        )}
      </Space>
    </Card>
  );
}
